module.exports = __webpack_public_path__ + "img/qrcode.4672e7c.png";